import React from "react";
import { Modal, Form, Button, Spinner } from "react-bootstrap";
import { IoMdClose } from "react-icons/io";
import { HiCamera } from "react-icons/hi";

const DroneModal = ({
    show,
    onHide,
    editingMachineIndex,
    machineFormValues,
    setMachineFormValues,
    handleMachineImageUpload,
    isMachineImageLoading,
    handleSaveMachineForm,
    user,
}) => {
    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    {editingMachineIndex !== null ? "Edit Machine" : "Add New Machine"}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>Machine Image</Form.Label>
                        <div
                            className="border rounded d-flex align-items-center justify-content-center bg-light position-relative"
                            style={{
                                width: "100%",
                                height: "200px",
                                overflow: "hidden",
                                cursor: "pointer",
                                backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='5' ry='5' stroke='%23333' stroke-width='1' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`,
                                border: 'none'
                            }}
                        >
                            {isMachineImageLoading ? (
                                <Spinner animation="border" variant="primary" />
                            ) : machineFormValues.image ? (
                                <>
                                    <img
                                        src={
                                            machineFormValues.image.startsWith("http")
                                                ? machineFormValues.image
                                                : `${user?.baseS3Url}${machineFormValues.image}`
                                        }
                                        alt="preview"
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                        }}
                                    />
                                    <div
                                        className="position-absolute top-0 end-0 p-2"
                                        style={{ zIndex: 10 }}
                                    >
                                        <div
                                            className="bg-white rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                                            style={{
                                                width: "32px",
                                                height: "32px",
                                                cursor: "pointer",
                                            }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                e.preventDefault();
                                                setMachineFormValues({ ...machineFormValues, image: "" });
                                            }}
                                        >
                                            <IoMdClose size={20} className="text-dark" />
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <label
                                    htmlFor="machine-img-upload"
                                    className="d-flex flex-column align-items-center justify-content-center w-100 h-100 cursor-pointer"
                                >
                                    <HiCamera className="text-muted mb-2" size={40} />
                                    <span className="text-muted">Upload Machine Image</span>
                                </label>
                            )}

                            {!machineFormValues.image && !isMachineImageLoading && (
                                <input
                                    type="file"
                                    id="machine-img-upload"
                                    hidden
                                    accept="image/*"
                                    onChange={handleMachineImageUpload}
                                    disabled={isMachineImageLoading}
                                />
                            )}
                        </div>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Manufacturer / Make</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="e.g. DJI"
                            value={machineFormValues.make}
                            onChange={(e) =>
                                setMachineFormValues({
                                    ...machineFormValues,
                                    make: e.target.value,
                                })
                            }
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Model</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="e.g. Mavic 3 Pro"
                            value={machineFormValues.model}
                            onChange={(e) =>
                                setMachineFormValues({
                                    ...machineFormValues,
                                    model: e.target.value,
                                })
                            }
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Type</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="e.g. Multirotor"
                            value={machineFormValues.type}
                            onChange={(e) =>
                                setMachineFormValues({
                                    ...machineFormValues,
                                    type: e.target.value,
                                })
                            }
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Cancel
                </Button>
                <Button
                    variant="primary"
                    onClick={handleSaveMachineForm}
                    disabled={isMachineImageLoading}
                >
                    {editingMachineIndex !== null ? "Update" : "Add Machine"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DroneModal;
